import { useLocation as baseUseLocation } from "react-router-dom";

export default function useLocation<T>(): ReturnType<typeof baseUseLocation> & {
  state: Partial<T> | null;
} {
  const res = baseUseLocation();
  return { ...res, state: res.state as Partial<T> | null };
}
